import {
  PublicClientApplication,
  Configuration,
  RedirectRequest,
  AccountInfo,
  EndSessionRequest
} from '@azure/msal-browser';
import config from 'config';
import accountInfoMock from '../../data/mock/accountInfo.json';

const setWindowsLocationRedirect = (redirect: string): string => {
  return `${window.location.origin}${redirect}`;
};

export const handleLogoutMsal = (homeAccountId: string): void => {
  if (config.AUTH.ENABLED === 'true') {
    const logoutRequest: EndSessionRequest = {
      account: msalAuth.getAccountByHomeId(homeAccountId),
      postLogoutRedirectUri: config.AUTH.LOGOUT_REDIRECT_URI
    };
    msalAuth.logoutRedirect({
      onRedirectNavigate: (url) => {
        return false;
      }
    });
  } else {
    window.location.replace(`${window.location.origin}`);
  }
};

export const msalConfig: Configuration = {
  auth: {
    clientId: config.AUTH.CLIENT_ID,
    authority: config.AUTH.AUTHORITY,
    redirectUri: setWindowsLocationRedirect(config.AUTH.LOGIN_REDIRECT_URI),
    postLogoutRedirectUri: setWindowsLocationRedirect(
      config.AUTH.LOGOUT_REDIRECT_URI
    )
  }
};

export const loginRequest: RedirectRequest = {
  scopes: [config.AUTH.SCOPES]
};

export const handleLoginMsal = async (): Promise<any> => {
  await msalAuth.loginRedirect(loginRequest);
};

export const getAccountInfo = (): AccountInfo | null => {
  const accountInfo: AccountInfo[] | null = msalAuth.getAllAccounts();
  if (accountInfo.length >= 1) {
    return accountInfo[0];
  }
  return null;
};

export const getAccountInfoMock = (): any => {
  return accountInfoMock;
};

export const getAccountInfoMsal = (): any => {
  if (config.AUTH.ENABLED === 'true') {
    return getAccountInfo();
  } else {
    return getAccountInfoMock();
  }
};

export const msalAuth = new PublicClientApplication(msalConfig);
